import Vue from 'vue';
import DASHBOARD from '../dashboard';
import store from '../store';

import { calculatePolygonBBox } from '../services/map/boundingBox';


Vue.mixin({
    beforeCreate() {
        const options = this.$options;
        if (options.polygonService) {
            this.$polygonService = options.polygonService;
        } else if (options.parent && options.parent.$polygonService) {
            this.$polygonService = options.parent.$polygonService;
        }
    },
});

DASHBOARD.namespace('DASHBOARD.Services.polygonService');

/**
 * polygon factory function
 * @return {*}        Object with polygon functions
 */
DASHBOARD.Services.createPolygonService = function (nedglobeApi) {

    const calculateBBox = calculatePolygonBBox;

    /**
     * Valideer de polygoon invoer
     * @param {string} coordinates door spaties gescheiden coordinatenlijst
     * @return {Boolean} true als de invoer correct gevalideerd is anders false
     */
    const validatePolygon = function (coordinates) {
        return new Promise((resolve) => {
            if (coordinates?.trim().length > 0) {
                // Check for unexpected characters (only digits, whitespace, ',' and '.' allowed)
                if (! /^[\d\s,.]+$/.test(coordinates)) {
                    resolve(false);
                }
                // Convert polygon to WKT in order to validate
                // Save the original GML2 or GML3 polygon
                let testCoordinates = coordinates.slice(0);
                // If polygon does not contain comma's, then place them
                if (coordinates.indexOf(',') === -1) {
                    testCoordinates = '';
                    const coordArray = coordinates.split(' ');
                    for (let i = 0; i < coordArray.length; i++) {
                        if (i % 2 === 1 && i !== coordArray.length - 1) {
                            testCoordinates += `${coordArray[i]},`;
                        } else {
                            testCoordinates += coordArray[i];
                        }
                        if (i !== coordArray.length - 1) {
                            testCoordinates += ' ';
                        }
                    }
                }

                try {
                    // Validate the polygon as WKT-geometry in the backend
                    const validationParams = { geometry: `POLYGON((${testCoordinates}))` };
                    store.dispatch('useApiData', {
                        name: 'OrganizationValidateWkt',
                        data: validationParams
                    }).then((result) => {
                        // Validation is done, return the result
                        resolve(result.data);
                    }, (e) => {
                        // Validation failed
                        resolve(false);
                    });
                } catch (e) {
                    // Call to back-end failed
                    resolve(false);
                }
            }
        });
    };

    /**
     * Valideer de omhullende rechthoek
     * eis: minX < maxX en minY < maxY
     * @param {array} bbox de te valideren bouning box
     * @return {bool} true als de rechthoek valide is, anders false
     */
    const validateBBox = function (bbox) {
        const minX = bbox[0] ? parseInt(bbox[0]) : bbox[0];
        const minY = bbox[1] ? parseInt(bbox[1]) : bbox[1];
        const maxX = bbox[2] ? parseInt(bbox[2]) : bbox[2];
        const maxY = bbox[3] ? parseInt(bbox[3]) : bbox[3];
        return (minX < maxX && minY < maxY);
    };

    return (function () {
        return {
            calculateBBox,
            validateBBox,
            validatePolygon
        };

    }());
};

export default DASHBOARD.Services.createPolygonService;
